import { customAlphabet } from "nanoid";
var alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
var customNanoid = customAlphabet(alphabet, 10);
var nanoid = function() {
    return customNanoid();
};
export default nanoid;
